import axios from "axios";
import * as constants from "./Constants";

const api_instance = axios.create({
  baseURL: constants.BASE_URL
});

export { api_instance };
